import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDDeleteButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('SearchableFormLayout', (theme) => ({
  withBorder: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: theme.shape.borderRadius,
  },
}));

const WithdrawalLayout = ({
  onDelete,
}) => {
  const classes = useStyles();

  const { resource } = useMetaLayoutContext();
  return (
    <div className={classes.withBorder}>
      <FDBox padding={4}>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr={'type'} />
          <MetaControlField attr={'fixedAmount'} />
          <MetaControlField attr={'percentOfBalance'} />
          <MetaControlField attr={'affectedByInflation'} />
          <MetaControlField attr={'frequency'} />
          <MetaControlField attr={'startType'} />
          <MetaControlField attr={'startDate'} />
          <MetaControlField attr={'startAtAge'} />
          <MetaControlField attr={'endType'} />
          <MetaControlField attr={'endDate'} />
          <MetaControlField attr={'endAtAge'} />
          <FDDeleteButton
            onClick={onDelete ? () => onDelete(resource) : undefined}
            size={'sm'}
          />
        </FDStack>
      </FDBox>
    </div>
  );
};

WithdrawalLayout.propTypes = {
  onDelete: PropTypes.func.isRequired,
};

export default WithdrawalLayout;
